import { useState, useEffect } from "react";
import { AttributeStatusTypes } from "@enums/attribute-status-types";
import { OOBStatusTypes } from "@enums/oob-status-types";
import { AttributeFormState } from "@idw-types/state/attribute-form-state";

export const useFrontAndBackAttributeImages = (
    attribute: AttributeFormState,
    onSetSubmitValue: (params: any) => void,
    onSetPickerValue: (params: any) => void
) => {
    const [images, setImages] = useState([]);
    useEffect(() => {
        let valueSource;
        let shouldSetValue = true;
        if (attribute.unableToVerifyAsync) {
            valueSource = attribute.inputData;
            shouldSetValue = false;
        } else {
            if (attribute.oobStatus === OOBStatusTypes.COMPLETE) {
                valueSource = attribute.valuesMap;
            }
            if (
                [AttributeStatusTypes.PICKER, AttributeStatusTypes.ASYNC_INCOMPLETE, AttributeStatusTypes.PASS].includes(
                    attribute.status
                )
            ) {
                valueSource = attribute.pickerDefaultAttribute.valuesMap;
            }
            if (attribute.isPlaceholder) {
                valueSource = attribute.prefillValueMap;
            }
        }
        if (valueSource) {
            const { frontImage, backImage } = valueSource;
            if (frontImage && backImage) {
                setImages([frontImage, backImage]);
            }
            if (shouldSetValue) {
                if (attribute.status === AttributeStatusTypes.PICKER) {
                    onSetPickerValue({
                        pickerData: {
                            id: attribute.pickerDefaultValue
                        }
                    });
                } else {
                    const inputData = { ...attribute.inputData };
                    inputData.frontImage = frontImage || '';
                    inputData.backImage = backImage || '';
                    onSetSubmitValue({ inputData });
                }
            }
        } else {
            setImages(["", ""]);
        }

        return () => { };
    }, [attribute.valuesMap, attribute.prefillValueMap]);

    return images;
}
